<footer>
    <div class="footer-v1 p-0">
        <div class="container">
            <div class="footer-top-v1">
                <div fxLayout="row wrap" class="col-gap">
                    <div
                    class="pt-4"
                        fxFlex.xs="100"
                        fxFlex.sm="100"
                        fxFlex.md="25"
                        fxFlex.lg="25"
                        fxFlex.xl="25"
                    >
                        <!-- <h5 class="mt-0">
                            {{ "footer.AboutCompany" | translate }}
                        </h5> -->
                        <a
                            [routerLink]="['/' + lang + '/']"
                            *ngIf="
                                lang == 'en' &&
                                environmentVariables?.WHITE_LOGO_EN
                            "
                        >
                            <img  loading="lazy" 
                                class="brand-footer"
                                [src]="environmentVariables?.WHITE_LOGO_EN"
                                [width]="environmentVariables?.logoWidth" 
                                [height]="environmentVariables?.logoHeight"
                                   alt="{{
                                    environmentVariables?.APP_NAME + ' logo'
                                }}"
                                [ngStyle]="{
                                    'width': environmentVariables?.logoWidth,
                                    'height': environmentVariables?.logoHeight
                                  }"
                            />
                        </a>
                        <a
                            [routerLink]="['/' + lang + '/']"
                            *ngIf="
                                lang == 'ar' &&
                                environmentVariables?.WHITE_LOGO_AR
                            "
                        >
                            <img  loading="lazy" 
                                class="brand-footer"
                                [src]="environmentVariables?.WHITE_LOGO_AR"
                                [width]="environmentVariables?.logoWidth" 
                                [height]="environmentVariables?.logoHeight"
                                   alt="brand image"
                                   [ngStyle]="{
                                    'width': environmentVariables?.logoWidth,
                                    'height': environmentVariables?.logoHeight
                                  }"
                            />
                        </a>
                        <p
                            class="menuRemoveMarginAboutCompany"
                            i18n="
                                CompanyDescription|CompanyDescription@@CompanyDescription"
                        >
                            {{
                                lang == "en"
                                    ? environmentVariables?.footerAboutCompanyEn
                                    : environmentVariables?.footerAboutCompanyAr
                            }}
                        </p>
                        <div
                         *ngIf="environmentVariables?.footerPaymentImages"
                            class="m-1 visaImage"
                            style="max-width: fit-content"
                        >
                            <img  loading="lazy" 
                                [src]="
                                    environmentVariables?.footerPaymentImages
                                "
                                   alt="Payment Images"
                                [ngStyle]="{
                                    width: environmentVariables?.footerPaymentImageStaticWidth
                                }"
                            />
                        </div>

                        <div class="mt-2">
                            <div class="centered-items">
                                <!-- <mat-icon
                                    class="material-icons footer-icon mr-1 main-color"
                                    >mail</mat-icon
                                > -->
                                <a
                                    href="mailto:{{
                                        environmentVariables?.INFO_EMAIL
                                    }}"
                                    >&nbsp;{{
                                        environmentVariables?.INFO_EMAIL
                                    }}</a
                                >
                            </div>
                        </div>
                        <div
                            class="mt-2"
                            *ngIf="environmentVariables?.HOTPHONE"
                        >
                            <div class="centered-items align-items-end">
                                <mat-icon
                                    class="material-icons footer-icon mr-1 main-color"
                                    aria-hidden="true"
                                    >call</mat-icon
                                >
                                <a
                                [ngClass]="
                                {'fs-20' : environmentVariables?.ENABLE_HOTLINE_IN_FOOTER_LARGE_SIZE  , 
                                'fs-16' :  !environmentVariables?.ENABLE_HOTLINE_IN_FOOTER_LARGE_SIZE
                                }"
                                    href="tel:{{
                                        environmentVariables?.HOTPHONE
                                    }}"
                                >
                                    {{
                                        lang == "en"
                                            ? environmentVariables?.HOTPHONE_LABEL
                                            : environmentVariables?.HOTPHONE_LABEL_AR
                                    }}
                                    {{ environmentVariables?.HOTPHONE }}</a
                                >
                            </div>
                        </div>
                        <div
                            class="mt-2 centered-items align-items-end"
                            *ngIf="environmentVariables?.HOTPHONE2"
                        >
                            <div class="centered-items">
                                <mat-icon
                                    class="material-icons footer-icon mr-1 main-color"
                                    aria-hidden="true"
                                    >call</mat-icon
                                >
                                <a
                                    href="tel:{{
                                        environmentVariables?.HOTPHONE2
                                    }}"
                                    [ngClass]="{'fs-20' : environmentVariables?.ENABLE_HOTLINE_IN_FOOTER_LARGE_SIZE  , 
                                  'fs-16' :  !environmentVariables?.ENABLE_HOTLINE_IN_FOOTER_LARGE_SIZE
                                  }"
                                >
                                    {{
                                        lang == "en"
                                            ? environmentVariables?.HOTPHONE2_LABEL
                                            : environmentVariables?.HOTPHONE2_LABEL_AR
                                    }}
                                    {{ environmentVariables?.HOTPHONE2 }}</a
                                >
                            </div>
                        </div>
                        <div
                            class="mt-2"
                            *ngIf="
                                environmentVariables?.APP_ADDRESS_EN ||
                                environmentVariables?.APP_ADDRESS_AR
                            "
                        >
                            <div class="centered-items">
                                <!-- <mat-icon
                                    class="material-icons footer-icon mr-1 main-color"
                                    aria-hidden="true"
                                    >home</mat-icon
                                > -->
                                <span>
                                    {{
                                        lang == "en"
                                            ? environmentVariables?.APP_ADDRESS_EN
                                            : environmentVariables?.APP_ADDRESS_AR
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        fxFlex.xs="100"
                        fxFlex.sm="100"
                        fxFlex.md="25"
                        fxFlex.lg="25"
                        fxFlex.xl="25"
                        class="d-flex align-content-start pt-4"
                    >
                        <div>
                            <h5>
                                {{ "footer.myAccount" | translate }}
                            </h5>
                            <p
                                class="menuRemoveMargin outline-none"
                                (click)="routing('account')"
                            >
                                {{ "footer.myProfile" | translate }}
                            </p>
                            <p
                                class="menuRemoveMargin outline-none"
                                (click)="routing('orders')"
                            >
                                {{ "footer.myOrders" | translate }}
                            </p>

                            <div class="secondrow">
                                <h5>
                                    {{ "footer.findUs" | translate }}
                                </h5>
                                <p
                                    class="menuRemoveMargin outline-none"
                                    [routerLink]="[
                                        '/' + lang + '/pages/contact'
                                    ]"
                                >
                                    {{ "footer.contactUs" | translate }}
                                </p>
                                <p
                                    *ngIf="
                                        environmentVariables?.OUR_BRANCHES_FOOTER_TYPE !=
                                            'off' &&
                                        environmentVariables?.OUR_BRANCHES_FOOTER_TYPE !=
                                            'link'
                                    "
                                    class="menuRemoveMargin outline-none"
                                    [routerLink]="[
                                        '/' + lang + '/pages/branches'
                                    ]"
                                >
                                    {{ "footer.branches" | translate }}
                                </p>
                                <a
                                    class="footer-link"
                                    *ngIf="
                                        environmentVariables?.OUR_BRANCHES_FOOTER_TYPE ==
                                        'link'
                                    "
                                    href="{{
                                        environmentVariables?.OUR_BRANCHES_FOOTER_LINK
                                    }}"
                                    target="_blank"
                                >
                                    {{ "footer.branches" | translate }}
                                </a>
                                <p
                                    class="menuRemoveMargin outline-none"
                                    [routerLink]="[
                                        '/' + lang + '/session/signup-affiliate'
                                    ]"
                                    *ngIf="
                                        environmentVariables?.enable_affiliate
                                    "
                                >
                                    {{ "footer.affiliate" | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        fxFlex.xs="100"
                        fxFlex.sm="100"
                        fxFlex.md="25"
                        fxFlex.lg="25"
                        fxFlex.xl="25"
                        class="d-flex align-content-start pt-4"
                    >
                        <div id="FirstFooterMenu">
                            <h5 class="mt-0">
                                {{ "footer.quickLinks" | translate }}
                            </h5>
                            <ul *ngIf="loadingStatic" class="app-nav-list">
                                <li
                                    class="app-nav-item"
                                    *ngFor="let fake of fakeArray"
                                >
                                    <div
                                        class="animate-shimmer shimmer-container"
                                    ></div>
                                </li>
                            </ul>
                            <p
                                *ngIf="environmentVariables?.ENABLE_SALES_PAGE"
                                class="menuRemoveMargin outline-none"
                                [routerLink]="['/' + lang + '/products/deals']"
                                [queryParams]="{sort:'high-discount'}"

                            >
                                {{ "footer.sales" | translate }}
                            </p>
                            <ng-container *ngFor="let page of staticPages">
                                <p
                                    *ngIf="page['in_footer']"
                                    class="menuRemoveMargin outline-none"
                                    (click)="redirectToLink(page)"
                                >
                                    {{
                                        lang == "en"
                                            ? page["title_en"]
                                            : page["title_ar"]
                                    }}
                                </p>
                            </ng-container>
                            <ng-container *ngFor="let form of dynamicForms">
                                <p
                                    *ngIf="form.in_footer"
                                    class="menuRemoveMargin outline-none"
                                    (click)="redirectToFormLink(form)"
                                >
                                    {{
                                        lang == "en"
                                            ? form["title_en"]
                                            : form["title_ar"]
                                    }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                    <div
                        fxFlex.xs="100"
                        fxFlex.sm="100"
                        fxFlex.md="25"
                        fxFlex.lg="25"
                        fxFlex.xl="25"
                        class="pt-4"
                    >
                        <div fxLayout="row wrap">
                            <div
                                fxLayout.xs="100"
                                fxLayout.sm="100"
                                fxLayout.md="50"
                                fxLayout.lg="50"
                                fxLayout.xl="50"
                            >
                                <div>
                                    <div>
                                        <p
                                            class="text-inverse"
                                            i18n="subcsribeInfo|subcsribeInfo@@FooterSubcsribeInfo"
                                        >
                                            <span *ngIf="
                                                !environmentVariables?.FOOTER_SUBSCRIBE_TEXT_AR &&
                                                !environmentVariables?.FOOTER_SUBSCRIBE_TEXT_EN">
                                                  {{ "footer.stayUpWithNews" | translate }}
                                            </span>  
                                          <span *ngIf="environmentVariables?.FOOTER_SUBSCRIBE_TEXT_AR ||environmentVariables?.FOOTER_SUBSCRIBE_TEXT_EN">
                                            {{ lang == "en" ? environmentVariables?.FOOTER_SUBSCRIBE_TEXT_EN : environmentVariables?.FOOTER_SUBSCRIBE_TEXT_AR}}
                                          </span>
                                        </p>
                                    </div>
                                    <div class="footer-subscription py-0">
                                        <form
                                            class="example-form"
                                            [formGroup]="subscribeForm"
                                            #subscribeFormReset="ngForm"
                                        >
                                            <div fxLayoutAlign="start center">
                                                <mat-form-field
                                                    class="w-100 color-underline-white"
                                                >
                                                    <input
                                                        style="color: var(--footer-input-color);"
                                                        class="text-inverse"
                                                        matInput
                                                        i18n-placeholder
                                                        placeholder="{{
                                                            'input_text.inputEmail' | translate
                                                        }}"
                                                        formControlName="email"
                                                    />
                                                    <mat-error
                                                    class="mt-3"
                                                        *ngIf="
                                                            subscribeForm
                                                                .controls.email
                                                                .errors &&
                                                            !subscribeForm
                                                                .controls.email
                                                                .errors
                                                                ?.required
                                                        "
                                                    >
                                                        {{
                                                            "validation_Input.validEmail"
                                                                | translate
                                                        }}</mat-error
                                                    >
                                                    <mat-error
                                                    class="mt-3"
                                                        *ngIf="
                                                            subscribeForm
                                                                .controls.email
                                                                .errors
                                                                ?.required &&
                                                            subscribeForm
                                                                .controls.email
                                                                .touched
                                                        "
                                                    >
                                                        {{
                                                            "validation_Input.requiredEmail"
                                                                | translate
                                                        }}</mat-error
                                                    >
                                                </mat-form-field>
                                                <button
                                                    mat-icon-button
                                                    class="text-inverse"
                                                    (click)="subscribe()"
                                                >
                                                    <mat-icon
                                                        class="material-icons sendArrowIcon"
                                                        >send</mat-icon
                                                    >
                                                </button>
                                            </div>
                                        </form>
                                    </div>

                                    <div class="mt-4">
                                        <span>
                                            <a
                                                class="pointer"
                                                *ngIf="
                                                    environmentVariables?.STORE_ANDROID_URL
                                                "
                                                href="{{
                                                    environmentVariables?.STORE_ANDROID_URL
                                                }}"
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mobile-apps-icons ml-1 mt-1"
                                                    [src]="environmentVariables?.FOOTER_STORE_ICONS_ANDROID ? environmentVariables?.FOOTER_STORE_ICONS_ANDROID : '../../../../assets/images/get-on-google-play.png' "
                                                       alt="android image"
                                                />
                                            </a>
                                        </span>
                                        <span>
                                            <a
                                                class="pointer"
                                                *ngIf="
                                                    environmentVariables?.STORE_APPLE_URL
                                                "
                                                href="{{
                                                    environmentVariables?.STORE_APPLE_URL
                                                }}"
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mobile-apps-icons ml-1 mt-1"
                                                    [src]="environmentVariables?.FOOTER_STORE_ICONS_IOS ? 
                                                    environmentVariables?.FOOTER_STORE_ICONS_IOS : '../../../../assets/images/get-on-app-store.png' "
                                                       alt="ios image"
                                                />
                                            </a>
                                        </span>
                                        <span>
                                            <a
                                                class="pointer"
                                                *ngIf="
                                                    environmentVariables?.STORE_HWAWEI_URL
                                                "
                                                href="{{
                                                    environmentVariables?.STORE_HWAWEI_URL
                                                }}"
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mobile-apps-icons ml-1 mt-1"
                                                    [src]="environmentVariables?.FOOTER_STORE_ICONS_HUAWEI ? environmentVariables?.FOOTER_STORE_ICONS_HUAWEI : 
                                                    '../../../../assets/images/get-on-app-gallary.png'  "
                                                       alt="huawei image"
                                                />
                                            </a>
                                        </span>
                                    </div>
                                    <div class="mt-2" id="socialMediaIcons">
                                        <span>{{
                                            lang == "en"
                                                ? "Follow " +
                                                  environmentVariables.APP_NAME
                                                : " تابعنا على " +
                                                  environmentVariables.APP_NAME_AR
                                        }}</span>
                                        <div class="social-row">
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_FACEBOOK
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_FACEBOOK
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mx-1 width-39"
                                                    src="{{
                                                        environmentVariables?.FACEBOOK_ICON
                                                            ? environmentVariables?.FACEBOOK_ICON
                                                            : './assets/images/icon_facebook_circle.png'
                                                    }}"
                                                       alt="facebook image"
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_INSTAGRAM
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_INSTAGRAM
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mx-1 width-39"
                                                    src="{{
                                                        environmentVariables?.INSTAGRAM_ICON
                                                            ? environmentVariables?.INSTAGRAM_ICON
                                                            : './assets/images/icon_social-instagram-circle.png'
                                                    }}"
                                                       alt="instagram image"
                                                />
                                            </a>

                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_YOUTUBE
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_YOUTUBE
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.YOUTUBE_ICON
                                                            ? environmentVariables?.YOUTUBE_ICON
                                                            : './assets/images/youtube-round.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="youtube image "
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_SNAPCHAT
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_SNAPCHAT
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.SNAPCHAT_ICON
                                                            ? environmentVariables?.SNAPCHAT_ICON
                                                            : './assets/images/snapchat.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="snapchat image"
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_TWITTER
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_TWITTER
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.TWITTER_ICON
                                                            ? environmentVariables?.TWITTER_ICON
                                                            : './assets/images/twitter.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="twitter image"
                                                />
                                            </a>
                                        </div>
                                        <span
                                            *ngIf="
                                                environmentVariables?.SOCIAL_LABEL_2
                                            "
                                        >
                                            {{
                                                lang == "en"
                                                    ? "Follow " +
                                                      environmentVariables?.SOCIAL_LABEL_2
                                                    : " تابعنا على " +
                                                      environmentVariables?.SOCIAL_LABEL_2_AR
                                            }}
                                        </span>
                                        <div class="social-row">
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_FACEBOOK_2
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_FACEBOOK_2
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mx-1 width-39"
                                                    src="{{
                                                        environmentVariables?.FACEBOOK_ICON
                                                            ? environmentVariables?.FACEBOOK_ICON
                                                            : './assets/images/icon_facebook_circle.png'
                                                    }}"
                                                       alt="facebook image"
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_INSTAGRAM_2
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_INSTAGRAM_2
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    class="mx-1 width-39"
                                                    src="{{
                                                        environmentVariables?.INSTAGRAM_ICON
                                                            ? environmentVariables?.INSTAGRAM_ICON
                                                            : './assets/images/icon_social-instagram-circle.png'
                                                    }}"
                                                       alt="instagram image"
                                                />
                                            </a>
                                        

                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_YOUTUBE_2
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_YOUTUBE_2
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.YOUTUBE_ICON
                                                            ? environmentVariables?.YOUTUBE_ICON
                                                            : './assets/images/youtube-round.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="youtube image"
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_SNAPCHAT_2
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_SNAPCHAT_2
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.SNAPCHAT_ICON
                                                            ? environmentVariables?.SNAPCHAT_ICON
                                                            : './assets/images/snapchat.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="snapchat image"
                                                />
                                            </a>
                                            <a
                                                *ngIf="
                                                    environmentVariables?.SOCIAL_URL_TWITTER_2
                                                "
                                                [href]="
                                                    environmentVariables?.SOCIAL_URL_TWITTER_2
                                                "
                                                target="_blank"
                                            >
                                                <img  loading="lazy" 
                                                    src="{{
                                                        environmentVariables?.TWITTER_ICON
                                                            ? environmentVariables?.TWITTER_ICON
                                                            : './assets/images/twitter.png'
                                                    }}"
                                                    class="mx-1 width-39"
                                                       alt="twitter image"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="environmentVariables?.SHOW_FOOTER_COPY_RIGHTS">
                <hr class="footerLine" />
                <div class="footer-bottom-v1">
                    <div class="col-gap">
                        <div
                            class="text-center"
                            [style.color]="
                                environmentVariables?.WEB_FOOTER_COPYRIGHTS_TEXT_COLOR ? 
                                    environmentVariables?.WEB_FOOTER_COPYRIGHTS_TEXT_COLOR : 
                                    '#ffffff'"
                            [innerHTML]="
                                lang == 'en'
                                    ? environmentVariables?.FOOTER_ENGLISH_CONTENT
                                    : environmentVariables?.FOOTER_ARABIC_CONTENT
                            "
                        ></div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</footer>
